import API from '../endpoints';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Faq, PaginatedResponse, TagsMatchMode } from '@repo/types';

// 30 minutes frontend cache for faq list query
const CACHE_TIME = 30 * 60 * 1000;

export type FaqsQueryArgs = {
  title?: string;
  description?: string;
  tags?: string;
  tagsMatchMode?: TagsMatchMode;
  ids?: string;
};

type QueryOptions = {
  enabled: boolean;
};

export const useFaqsQuery = (args: FaqsQueryArgs, options?: QueryOptions) => {
  return useQuery({ queryKey: ['faqs', args], queryFn: fetchFaqs, staleTime: CACHE_TIME, ...(options ?? {}) });
};

const fetchFaqs: QueryFunction<PaginatedResponse<Faq>, [string, FaqsQueryArgs]> = async ({ queryKey }) => {
  const [, params] = queryKey;

  const { data } = await axios.get<PaginatedResponse<Faq>>(API.endpoints.faqs, {
    params,
  });
  return data;
};
